/*=============================
=            Slider           =
=============================*/

import Vue from "vue";
import SlickSlider from "../vue/slider/SlickSlider";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
// or only core styles
import "@splidejs/splide/css/core";

[].slice
    .call(document.querySelectorAll('section[class*="_slider"]'))
    .forEach(function (section) {
        var slider = section.querySelector(".slider-container");

        new Vue({
            el: slider,
            components: { SlickSlider },
        });
    });

document.addEventListener("DOMContentLoaded", function () {
    [].slice
        .call(document.querySelectorAll(".testimonial .quote"))
        .forEach(function (quote) {
            var dots = quote.querySelector(".dots"),
                moreText = quote.querySelector(".remainingText"),
                btnText = quote.querySelector(".readmoreBtn");

            if (btnText) {
                btnText.addEventListener("click", function () {
                    if (dots.style.display === "none") {
                        dots.style.display = "inline";
                        btnText.textContent =
                            btnText.getAttribute("data-readmore");
                        btnText.classList.remove("open");
                        moreText.style.display = "none";
                    } else {
                        dots.style.display = "none";
                        btnText.textContent =
                            btnText.getAttribute("data-readless");
                        btnText.classList.add("open");
                        moreText.style.display = "inline";
                    }
                });
            }
        });
});

/*
 * Donor Autoscroll settings
 * */

if (document.getElementById("donor-slider")) {
    const options = {
        type: "loop",
        drag: false,
        focus: "center",
        arrows: false,
        pagination: !1,
        perPage: 6,
        autoWidth: !0,
        autoScroll: {
            speed: 0.3,
            pauseOnHover: !1,
            pauseOnFocus: !1,
        },
    };

    new Splide(".splide-1", options).mount({ AutoScroll });

    // Slide 2
    options.autoScroll.speed = 0.2;
    new Splide(".splide-2", options).mount({ AutoScroll });

    // Slide 3
    options.autoScroll.speed = 0.6;
    new Splide(".splide-3", options).mount({ AutoScroll });
    // Slide 4
    options.autoScroll.speed = 0.5;
    new Splide(".splide-4", options).mount({ AutoScroll });
    // Slide 5
    options.autoScroll.speed = 0.2;
    new Splide(".splide-5", options).mount({ AutoScroll });
}
